import { useHeaderHeight } from "@react-navigation/elements";
import { ReactNode } from "react";
import { Platform, KeyboardAvoidingView as RNKeyboardAvoidingView } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

const KeyboardAvoidingView = ({ children, isModalScreen }: { children: ReactNode; isModalScreen?: boolean }) => {
  const headerHeight = useHeaderHeight();
  const insets = useSafeAreaInsets();
  const modalScreenHeight = insets.top + headerHeight;

  return (
    <RNKeyboardAvoidingView
      keyboardVerticalOffset={isModalScreen ? modalScreenHeight : headerHeight}
      behavior={Platform.OS === "ios" ? "padding" : "height"}
      className="flex-1"
    >
      {children}
    </RNKeyboardAvoidingView>
  );
};

export default KeyboardAvoidingView;
